/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Correct_Reading_SpeedInputs */

const en_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Correct Reading Speed`)
};

const fr_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correction auto de la vitesse de lecture`)
};

const de_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesegeschwindigkeit automatisch korrigieren`)
};

const it_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correzione automatica della velocità di lettura`)
};

const ru_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая коррекция скорости чтения`)
};

const es_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrección automática de velocidad de lectura`)
};

const zh_cn2_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动校正阅读速度`)
};

const ja_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動修正読み取り速度`)
};

const hi_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वतः सुधार पठन गति`)
};

const pt_pt2_auto_correct_reading_speed = /** @type {(inputs: Auto_Correct_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correção automática da velocidade de leitura`)
};

/**
* | output |
* | --- |
* | "Auto Correct Reading Speed" |
*
* @param {Auto_Correct_Reading_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_correct_reading_speed = /** @type {((inputs?: Auto_Correct_Reading_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Correct_Reading_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_correct_reading_speed(inputs)
	if (locale === "de") return de_auto_correct_reading_speed(inputs)
	if (locale === "it") return it_auto_correct_reading_speed(inputs)
	if (locale === "ru") return ru_auto_correct_reading_speed(inputs)
	if (locale === "es") return es_auto_correct_reading_speed(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_correct_reading_speed(inputs)
	if (locale === "ja") return ja_auto_correct_reading_speed(inputs)
	if (locale === "hi") return hi_auto_correct_reading_speed(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_correct_reading_speed(inputs)
	return en_auto_correct_reading_speed(inputs)
});